import {
  getOrderDataById,
  getOrderOverviewData,
  getOrderListData,
} from '../orders/mockData'
import {
  ensureUniquenessAfterAddOrChangeToListData,
  propagateAfterAddsChangesOrDeletes,
} from '../../modules/mockDataCommon'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { _storeEntityDataListToLocalForage } from '../../modules/mockDataStorageManager'
import type { IOrderTeamMember } from '~/types/order/models'
import type { TEntityId } from '~/types/models'
import {
  _getTMDataById,
  getTeamMemberListData,
} from '~/api/msw/api/teamMembers/mockData'
import { propagateOrderTeamMemberData } from '~/cynqueModules/dataObjects/OrderTeamMember'
import { propagateFlagChangeAfterDelete } from '~/cynqueModules/propagateFlagChangeAfterDelete'

const mn = `[api/msw/api/orderTeamMembers/mockData]`

const orderTeamMemberListData = undefined as unknown as IOrderTeamMember[]

export const getOrderTeamMemberListData = getListDataFunctionFactory<
  IOrderTeamMember[]
>({
  listData: orderTeamMemberListData,
  storageKey: 'orderteammembers',
  getStartingListData: getStartingOrderTeamMemberListData,
})

export async function getOrderTeamMemberDataById(id: string) {
  const list = await getOrderTeamMemberListData()
  if (!list) {
    throw new Error(`getOrderTeamMemberListData returned undefined/null`)
  }
  return list.find((otm: IOrderTeamMember) => otm.id === id)
}

export async function getOrderTeamMemberListDataByOrderId(
  id: TEntityId
): Promise<IOrderTeamMember[]> {
  const list: IOrderTeamMember[] = await getOrderTeamMemberListData()
  if (!list) {
    throw new Error(`getOrderTeamMemberListData returned undefined/null`)
  }
  const orderTeamMembers = list.filter((otm) => otm.order.id === id) ?? []
  return orderTeamMembers
}

export async function processAfterAddOrChangeOrderTeamMemberListData({
  targetItem,
  updatedEntityData,
  listData,
}: {
  targetItem: IOrderTeamMember
  updatedEntityData: Partial<IOrderTeamMember>
  listData: IOrderTeamMember[]
}) {
  const fn = `${mn} processAfterAddOrChangeToOrderTeamMemberListData |`
  console.debug(`${fn} called`)
  await ensureUniquenessAfterAddOrChangeToListData<IOrderTeamMember>({
    targetItem,
    updatedEntityData,
    listData,
    propertyNameArray: ['isOwner', 'isAssignedTo'],
    entityKeyBase: 'orderteammembers',
    getListDataFn: getOrderTeamMemberListData,
    filterFn: (otm: IOrderTeamMember) => otm.order.id === targetItem.order.id,
  })
  await propagateAfterAddsChangesOrDeletes<IOrderTeamMember>({
    sourceItem: targetItem,
    sourceEntityName: 'orderTeamMember',
    targetEntityInSourceItem: 'order',
    getOverviewFn: getOrderOverviewData,
    propagationFn: propagateOrderTeamMemberData,
    getTargetEntityListDataFn: getOrderListData,
    entityKeyBase: 'orders',
  })
}

export async function processAfterDeleteOfOrderTeamMemberListData({
  deletedEntityData,
}: {
  deletedEntityData: IOrderTeamMember
}) {
  const fn = `${mn} processAfterDeleteOfOrderTeamMemberListData |`
  console.debug(`${fn} called...`)
  await propagateAfterAddsChangesOrDeletes<IOrderTeamMember>({
    sourceItem: deletedEntityData,
    sourceEntityName: 'orderTeamMember',
    targetEntityInSourceItem: 'order',
    getOverviewFn: getOrderOverviewData,
    propagationFn: propagateOrderTeamMemberData,
    getTargetEntityListDataFn: getOrderListData,
    entityKeyBase: 'orders',
  })
}

export async function getStartingOrderTeamMemberListData(): Promise<
  IOrderTeamMember[]
> {
  const tmList = await getTeamMemberListData()
  const mo0001 = { id: 'XXORD0001', label: 'DIA - All Locations' }
  return [
    {
      id: 'XXORDTM0001',
      hrid: 'ORDTM0001',
      order: mo0001,
      teamMember: _getTMDataById('XXTM0001', tmList)!,
      splitFraction: 0.1,
      isOwner: true,
      isAssignedTo: true,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXORDTM0005',
      hrid: 'ORDTM0005',
      order: mo0001,
      teamMember: _getTMDataById('XXTM0005', tmList)!,
      splitFraction: 0.05,
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
